const filters = {
    // 截取字符串长度
    // @param str 过滤的字符串
    // @param len  字符串长度限制
    // 绑定示例 {{ text | cal(20)}}
  
    calc: function (str, len) {
  
      if (str) {
        //length属性读出来的汉字长度为1
        if (str.length * 2 <= len) {
          return str;
        }
        var strlen = 0;
        var s = "";
        for (var i = 0; i < str.length; i++) {
          s = s + str.charAt(i);
          if (str.charCodeAt(i) > 128) {
            strlen = strlen + 2;
            if (strlen >= len) {
              return s.substring(0, s.length - 1) + "...";
            }
          } else {
            strlen = strlen + 1;
            if (strlen >= len) {
              return s.substring(0, s.length - 2) + "...";
            }
          }
        }
        return s;
      } else {
        return false;
      }
    },
  
    
  }
  export default (Vue) => {
    Object.keys(filters).forEach(key => {
      Vue.filter(key, filters[key])
    })
  }
  


// WEBPACK FOOTER //
// ./src/utils/filters.js